import React, { useState, useCallback, useRef, useEffect } from "react";
import { ActionButton, IComboBoxOption, IComboBox, DirectionalHint } from "@fluentui/react";
import CustomComboBox from "components/shared/constraints/CustomComboBox";
import icons from "components/shared/Icons";

interface PolicyCriteriaAdderProps {
  availableConstraints: any[];
  usedConstraints: string[];
  onConstraintSelected: (option?: IComboBoxOption) => void;
  disabled?: boolean;
}

function PolicyCriteriaAdder({ 
  availableConstraints, 
  usedConstraints,
  onConstraintSelected,
  disabled = false,
}: PolicyCriteriaAdderProps) {
  const comboBoxRef = useRef<IComboBox>(null);
  const [addConstraints, setAddConstraints] = useState(false);

  // Transform constraints into combo box options
  const constraintOptions: IComboBoxOption[] = availableConstraints.map(constraint => ({
    key: constraint.key || constraint.name || constraint.id,
    text: constraint.display || constraint.displayName || constraint.name || constraint.title,
    data: constraint,
  }));

  const onOpenClick = useCallback(
    (shouldFocus: boolean) => comboBoxRef.current?.focus(shouldFocus),
    []
  );

  useEffect(() => {
    if (addConstraints) {
      onOpenClick(true);
    }
  }, [addConstraints, onOpenClick]);

  const handleAddCriteriaClick = () => {
    setAddConstraints(true);
  };

  if (!addConstraints) {
    return (
      <ActionButton
        data-automation-id="policy-criteria-adder-add-criteria-button"
        iconProps={icons.add}
        onClick={handleAddCriteriaClick}
        disabled={disabled || availableConstraints.length === 0}
        styles={{
          root: {
            height: "32px",
            minWidth: "120px",
          },
          rootDisabled: {
            backgroundColor: "#f3f2f1",
          },
        }}
      >
        Add Criteria
      </ActionButton>
    );
  }

  return (
    <CustomComboBox
      componentRef={comboBoxRef}
      options={constraintOptions}
      onOptionSelected={(option?: IComboBoxOption) => {
        if (option) {
          onConstraintSelected(option);
        }
      }}
      defaultKey={usedConstraints}
      noStyleChange={false}
      multiSelect
      onMenuDismissed={() => {
        setTimeout(() => {
          setAddConstraints(false);
        }, 0);
      }}
      calloutProps={{
        directionalHint: DirectionalHint.bottomLeftEdge,
        directionalHintFixed: true,
        calloutMaxHeight: 450,
      }}
      // style={{
      //   maxWidth: "100%",
      // }}
    />
  );
}

export default PolicyCriteriaAdder;